import {ZERO_STRING} from "./consts";

export const getPadTime = (time) => time.toString().padStart(2, ZERO_STRING);
